<template>
  <div>
    <div class="pedido-shell" @click="$emit('openPedido', p)">
      <h6 class="mb-2 text-limit pedido-title"><b>#{{p.id_contador}}</b> - {{p.nome_cliente}}</h6>
      <div class="small pedido-meta">
        <div class="pedido-address">
          <div><i class="fa-solid fa-location-dot"></i> {{p.logradouro}}, {{p.numero}}, <span class="text-nowrap">{{p.bairro}}</span></div>
          <div v-if="p.complemento">{{p.complemento}}</div>
        </div>
        <div class="pedido-time">
          <span><i class="fa-solid fa-calendar-days"></i> {{ formatarData(p.data_pedido) }}</span>
          <span class="mx-1"> | </span>
          <span v-if="p.data_agendamento"><b>Agendado:</b> {{ formatarData(p.data_agendamento) }}</span>
          <span v-else><b>Previsão:</b> {{ formatarHora(p.data_previsao) }}</span>
        </div>
      </div>
      <div class="d-flex align-items-center flex-wrap pedido-payment">
        <img :src="p.img_pagamento" :alt="`Pagamento: ${p.nome_pagamento}`" class="pgm-pedido">
        <div class="small">
          <span class="mr-1">{{ p.nome_pagamento }}:</span>
          <b>{{ p.valor_total | valor }}</b>
        </div>
        <span class="ml-2">
          <span class="badge badge-success mr-1" v-if="isPedidoPago(p)">Pedido Pago</span>
          <span class="badge badge-warning mr-1" v-else-if="p.nome_pagamento === 'Venda a Prazo'">Pedido a Prazo</span>
          <span class="badge badge-primary mr-1" v-else>Cobrar na Entrega</span>
        </span>
      </div>
    </div>
    <div
      class="text-center pedido-footer"
      v-if="!pertenceRota || status >= 3"
    >
      <div v-if="status < 3">
        <a href="javascript:" class="btn-toggle" @click.stop="$emit('toggleStatus', '2', p)" v-if="status === '1' && !pertenceRota">
          Iniciar Entrega <i class="fa-solid fa-location-arrow ml-1"></i>
        </a>
        <a href="javascript:" class="btn-toggle" @click.stop="$emit('toggleStatus', '3', p)" v-else-if="status === '2'">
          Entregar Pedido <i class="fa-solid fa-circle-check ml-1"></i>
        </a>
      </div>
      <a href="javascript:" class="btn-toggle" @click.stop="$emit('openPedido', p)" v-else>
        <i class="fa-solid fa-receipt mr-1"></i> Visualizar Pedido
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pedido",
  props: {
    p: Object,
    selected: null,
    status: [String, Number],
    pertenceRota: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatarData(valor) {
      if (!valor) return '';

      const data = this.$dayjs(valor);
      return data.isValid() ? data.format('DD/MM/YYYY HH:mm') : valor;
    },

    formatarHora(valor) {
      if (!valor) return '';

      const data = this.$dayjs(valor);
      return data.isValid() ? data.format('HH:mm') : valor;
    },

    isPedidoPago(pedido) {
      return pedido?.pago === true || pedido?.pedido_pago === '1' || pedido?.categoria === '5';
    }
  },
  filters: {
    max(text) {
      return text && text.length > 22 ? text.slice(0 , 22) + '...' : text;
    },

    statusEntrega(status) {
      switch (status) {
        case '1':
          return 'Aguardando';
        case '2':
          return 'Em Rota';
        case '3':
          return 'Entregue';
      }
    }
  }
}
</script>

<style scoped>
.pedido-shell {
  padding-top: 2px;
}

.pgm-pedido {
  width: 18px;
  display: block;
  margin-right: 8px;
}

.pedido-title {
  font-size: 0.96rem;
  line-height: 1.2rem;
}

.pedido-meta {
  color: var(--text-muted);
}

.pedido-address,
.pedido-time {
  margin-bottom: 7px;
}

.pedido-payment {
  padding-top: 0;
  margin-top: 0;
  align-items: center;
}

.pedido-footer {
  margin-top: 12px;
  margin-bottom: 6px;
  padding-top: 5px;
  border-top: 1px solid var(--border-color);
}

a.btn-toggle {
  color: var(--text-default);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 0 6px;
  font-weight: 600;
}

.text-limit {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
